"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mappings = {
    hosts: {
        'www.quantcast.com': 'production',
        'test.quantcast.com': 'test',
        'wqa.quantcast.com': 'test',
        'zoltan.quantcast.com': 'staging',
        'wst.quantcast.com': 'staging',
        localhost: 'dev'
    },
    apps: {
        '/measure/properties': 'Measure_Dashboard',
        '/measure/campaigns': 'Measure_Campaign_Reporting',
        '/measure/': 'Measure',
        '/advertise/campaigns': 'Advertise_CMS',
        '/advertise/audiences/insights': 'Advertise_Brand_Audience-Insights',
        '/component/': 'Callahan_Docs',
        '/callahan/styles/': 'Callahan_Docs'
    }
};
var request = {
    component: {},
    app: null,
    framework: null,
    env: null,
    meta: function (app, framework, env) {
        this.app = app;
        this.framework = framework;
        this.env = env;
    },
    add: function (component) {
        if (Object.keys(this.component).indexOf(component) === -1) {
            this.component[component] = 1;
        }
        else {
            this.component[component]++;
        }
    },
    send: function () {
        var base = "https://static-test.quantcast.com/FE-callahan-monitoring";
        var body = {
            component: this.component,
            app: this.app,
            framework: this.framework,
            env: this.env
        };
        var opts = {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(body)
        };
        this.component = {};
        fetch(base, opts);
    }
};
window.setInterval(function () {
    if (Object.keys(request.component).length) {
        request.send();
    }
}, 20000);
var tracker = function (component, location) {
    if (component) {
        request.add(component.name);
        if (!request.app) {
            var newHost = void 0, newApp = void 0;
            if (location) {
                newHost = Object.keys(mappings.hosts).find(function (host) {
                    return location.hostname.indexOf(host) > -1;
                });
                newApp = Object.keys(mappings.apps).find(function (app) {
                    return (location.pathname + location.hash).indexOf(app) > -1;
                });
            }
            var env = newHost ? mappings.hosts[newHost] : 'undefined';
            var currApp = newApp ? mappings.apps[newApp] : 'undefined';
            request.meta(currApp, 'react', env);
        }
    }
};
exports.default = (function (name) {
    var opts = {
        framework: 'react',
        name: name
    };
    tracker(opts, window.location);
});
//# sourceMappingURL=monitoring.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/services/monitoring.js
// module id = 2
// module chunks = 0